import $ from 'gridstrap/lib/gs-zepto';
import smoothScroll = require('gridstrap/lib/smooth-scroll');

export class GSHighlightAnimation {

	//
	// Properties
	//

	private root;
	private document;
	private body;

	get id() { return this.root.data('gsHighlightAnimationId') + ''; }
	set isHighlighted(value) { this.root.toggleClass('is-highlighted', !!value); }
	set isAnimated(value) { this.root.toggleClass('is-animated', !!value); }

	get isMatch() {
		let pattern = /(^\?|&)highlight=(.*)($|&)/i;
		let match   = location.search.match(pattern);
		let list    = ((match && match[2]) || '').split(',');
		return list.indexOf(this.id) >= 0;
	}

	get isFirstHighlight() {
		let all = $('.gs-HighlightAnimation.is-highlighted');
		if (all.length == 0) return false;

		let firstId = all.gs(0).id;
		return firstId == this.id;
	}

	//
	// Methods
	//

	scroll() {
		let offset = this.root.offset().top;
		smoothScroll.animateScroll(offset - 60);
		this.document.one('scrollStop', () => this.body.trigger('gs:highlightAnimationScrollDone'));
	}

	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		this.root = $(root);
		this.document = $(document);
		this.body = $('body');

		if (!this.isMatch) return;
		this.isHighlighted = true;
	}

	gsOnInit() {
		if (this.isMatch) this.body.on('gs:highlightAnimationScrollDone', () => this.isAnimated = true);
		if (this.isFirstHighlight) this.scroll();
	}
}
